import { render, staticRenderFns } from "./ItinerarySectionItem.vue?vue&type=template&id=653378b2&scoped=true&"
import script from "./ItinerarySectionItem.vue?vue&type=script&lang=js&"
export * from "./ItinerarySectionItem.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySectionItem.vue?vue&type=style&index=0&id=653378b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653378b2",
  null
  
)

export default component.exports